let current = null
let started = false

async function fetchDataVersion() {
  try {
    const res = await fetch('/version.json?_=' + Date.now(), { cache: 'no-store' })
    if (!res.ok) return null
    const json = await res.json()
    if (json && json.code === 0 && typeof json.data === 'string') return json.data
    return null
  } catch (e) {
    return null
  }
}

export function startVersionCheck(interval = 600000, mode = 'confirm') {
  // console.log('startVersionCheck called with interval:', interval, 'ms');
  if (started) return
  started = true

  const check = async () => {
    const v = await fetchDataVersion()
    if (!v) return

    if (!current) {
      current = v
      return
    }

    if (current !== v) {
      if (mode === 'force') {
        location.reload(true)
      } else {
        const ok = window.confirm(`The system has been updated.（${current} → ${v}），Refresh?？`)
        if (ok) location.reload(true)
      }
    }
  }

  check()
  setInterval(check, interval)
}
